import React, { useState } from "react";
import { Input, AutoComplete } from "antd";
import styles from "./styles.module.scss";

const { Search } = Input;

const Support = () => {
  const [options, setOptions] = useState([]);

  const handleSearch = (value) => {
    setOptions(
      !value
        ? []
        : [
            { value: "搜索提示语1" },
            { value: "搜索提示语2" },
            { value: "搜索提示语3" },
          ]
    );
  };

  return (
    <div className={styles.supportContent}>
      <div className={styles.support}>
        <h3>服务支持</h3>
        <div className={styles.search}>
          <AutoComplete
            options={options}
            onSelect={(value) => console.log("onSelect", value)}
            onSearch={handleSearch}
          >
            <Search
              placeholder="请输入内容"
              size="large"
              style={{ width: 500 }}
            />
          </AutoComplete>
        </div>
      </div>
      <div className={styles.supportDetail}>
        <div className={styles.user}>
          <h3>用户手册</h3>
          <div className={styles.userList}>
            <ul>
              <li>
                <p>1. 使用内容1</p>
                <button>下载</button>
              </li>
              <li>
                <p>2. 使用内容2</p>
                <button>下载</button>
              </li>
              <li>
                <p>3. 使用内容3</p>
                <button>下载</button>
              </li>
            </ul>
          </div>
        </div>
        <div className={styles.userTutorial}>
          <h3>使用教程</h3>
          <div className={styles.tutorialList}>
            <ul>
              <li>
                <p>xxx的使用教程1</p>
                <button>查看详情</button>
              </li>
              <li>
                <p>xxx的使用教程2</p>
                <button>查看详情</button>
              </li>
            </ul>
          </div>
        </div>
        <div className={styles.userExample}>
          <h3>使用范例</h3>
          <div className={styles.userExampleList}>
            <ul>
              <li>
                <p>xxx的使用范例1</p>
                <button>查看详情</button>
              </li>
              <li>
                <p>xxx的使用范例2</p>
                <button>查看详情</button>
              </li>
            </ul>
          </div>
        </div>
        <div className={styles.FAQ}>
          <h3>常见问题及解答</h3>
          <div className={styles.FAQList}>
            <ul>
              <li>
                <p>常见问题1</p>
                <button>查看详情</button>
              </li>
              <li>
                <p>常见问题2</p>
                <button>查看详情</button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Support;
